module.exports = __webpack_public_path__ + "static/media/A1-32-Deskderb-cod140.d814dadf.png";